"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledBadges = void 0;
var react_bootstrap_1 = require("react-bootstrap");
var styled_components_1 = __importStar(require("styled-components"));
exports.StyledBadges = (0, styled_components_1.default)(react_bootstrap_1.Container)(function (_a) {
    var _b = _a.theme, Utilities = _b.Utilities, Colors = _b.Colors, Dimensions = _b.Dimensions, Typography = _b.Typography, transformation = _a.transformation;
    return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n    padding: 0;\n    flex-wrap: wrap;\n    gap: 6px;\n\n    .text-badge {\n      ", "\n      padding: 0;\n    }\n\n    .badge {\n      ", "\n      background-color: ", ";\n      border: solid 0.5px ", ";\n      border-radius: ", ";\n      height: 1.4rem;\n      min-width: 4.5rem;\n      color: ", ";\n      font-weight: ", ";\n      text-transform: ", ";\n      margin-right: 0;\n    }\n  "], ["\n    ", "\n    padding: 0;\n    flex-wrap: wrap;\n    gap: 6px;\n\n    .text-badge {\n      ", "\n      padding: 0;\n    }\n\n    .badge {\n      ", "\n      background-color: ", ";\n      border: solid 0.5px ", ";\n      border-radius: ", ";\n      height: 1.4rem;\n      min-width: 4.5rem;\n      color: ", ";\n      font-weight: ", ";\n      text-transform: ", ";\n      margin-right: 0;\n    }\n  "])), Utilities.Flex.center('vertical'), Utilities.Flex.center('vertical'), Utilities.Flex.center('both'), Colors.Secondary.inactive, Colors.Secondary.main, Dimensions.Borders.Radiuses.medium, Colors.primary, Typography.Weights.normal, transformation);
});
var templateObject_1;
